import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { type AsChildProps, Slot } from "@/components/_molecules/slot.tsx";
import { useUpdateLabel } from "@/domain/label/hooks/api/use-update-label";

type AddLabelToGroupActionProps = AsChildProps<React.ButtonHTMLAttributes<HTMLButtonElement>> & {
  style?: React.CSSProperties;
  className?: string;
  label: {
    id: string;
    labelGroupId?: string | null;
  };
  labelGroup: {
    id: string;
    title: string;
  };
  workspace: {
    id: string;
  };
};

export const AddLabelToGroupAction = ({ label, labelGroup, asChild, ...props }: AddLabelToGroupActionProps) => {
  const { t } = useTranslation("common");
  const Comp = asChild ? Slot : "button";

  const { updateLabel } = useUpdateLabel({
    onCompleted: () => {
      toast.success(t("label.addToGroupSuccess"), {
        description: t("label.addToGroupSuccessDescription", { groupTitle: labelGroup.title }),
      });
    },
    onError: () => {
      toast.error(t("errors.title"), { description: t("label.addToGroupError") });
    },
  });

  async function handleClick() {
    await updateLabel({ id: label.id, labelGroupId: labelGroup.id });
  }

  return <Comp {...props} onClick={handleClick} />;
};
